export const IRRIGATION_CONDITIONS = {
  NO_IRRIGATION: "No irrigation",
  EARLY: "Early",
  LATE: "Late",
  LIMIT: "Limit",
};

export const CONDITION_CHIP_CONFIG = {
  [IRRIGATION_CONDITIONS.NO_IRRIGATION]: {
    color: "success",
    priority: 4,
    labelKey: "irrigation.no_irrigation",
  },
  [IRRIGATION_CONDITIONS.EARLY]: {
    color: "info",
    priority: 3,
    labelKey: "irrigation.early",
  },
  [IRRIGATION_CONDITIONS.LATE]: {
    color: "warning",
    priority: 2,
    labelKey: "irrigation.late",
  },
  [IRRIGATION_CONDITIONS.LIMIT]: {
    color: "error",
    priority: 1,
    labelKey: "irrigation.limit",
  },
};

export const getChipColorByCondition = (condition) => {
  return CONDITION_CHIP_CONFIG[condition]?.color || "default";
};

export const getPriorityByCondition = (condition) => {
  return CONDITION_CHIP_CONFIG[condition]?.priority || 99;
};

export const requiresIrrigation = (condition) => {
  return condition && condition !== IRRIGATION_CONDITIONS.NO_IRRIGATION;
};
